module.exports = __webpack_public_path__ + "static/img/default-black.1b0e14ca.jpg";